module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": _vm.formData.id == 0 ?
        'Novo GHE' :
        this.$store.state.ltcat.title +
        _vm.formData.ghe +
        ' (' +
        _vm.formData.descricao +
        ')',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onClose": _vm.onClose,
      "onSave": _vm.tagConfig == 'tab-cadastro' ? this.salvar : null,
      "width": "98%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Informações do GHE\n          ")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1), _vm._v(" "), (_vm.formData.id > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-risco"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" Medições (" + _vm._s(_vm.formData.medicoes.length) + ")\n          ")]), _vm._v(" "), _c('Medicao', {
    attrs: {
      "parent": this,
      "ltcat": _vm.parent.ltcat
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.id > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-conclusao"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-wpforms"
  }), _vm._v(" Conclusão Técnica (" + _vm._s(_vm.formData.conclusoes.length) + ")\n          ")]), _vm._v(" "), _c('ConclusaoTecnica', {
    attrs: {
      "parent": this,
      "ltcat": _vm.parent.ltcat
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.id > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-funcao"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" Funções (" + _vm._s(_vm.formData.funcoes.length) + ")\n          ")]), _vm._v(" "), _c('Funcao', {
    attrs: {
      "parent": this,
      "ltcat": _vm.parent.ltcat
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.id > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-funcionarios"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-address-card"
  }), _vm._v(" Funcionário (" + _vm._s(_vm.formData.funcionarios.length) + ")\n          ")]), _vm._v(" "), _c('Funcionario', {
    attrs: {
      "parent": this,
      "ltcat": _vm.parent.ltcat
    }
  })], 1) : _vm._e()], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-048c56f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/ltcat/ghe/editar.vue
// module id = 1401
// module chunks = 45